import React, { useState, useEffect } from 'react';
import { ConfigProvider } from 'antd';
import { GetAllSolicitacoesByUnidadeWithOptionalFilters } from "@services/Solicitacao/Index.jsx";
import StatusSolicitacaoComp from '@components/UI/StatusSolicitacao/Index.jsx';
import { formatDateToBR } from '@utils/FormatDate.jsx';
import { NavigateSolicitacao } from '@components/Solicitacao/Shared/NavigateSolicitacao/Index.jsx';
import ptBR from 'antd/es/locale/pt_BR';
import { StyledTable } from "@styles/datatables/datatable-antd.js";
import { Spinner } from '@styles/loading.js';
import TextBlock from "@components/UI/TextBlock/Index..jsx";
import { useAppAuth } from '@contexts/AuthContext';

const GridConsultasSolicitacoesUnidadeGerencia = ({ state, setData, onDelete, filters }) => {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { idUnidadeGerencia } = useAppAuth();

  // Busca os dados da API
  const fetchData = async (currentPage, currentRowsPerPage, filters = {}) => {
    setLoading(true);
    try {
      const response = await GetAllSolicitacoesByUnidadeWithOptionalFilters(
        currentPage, currentRowsPerPage, idUnidadeGerencia, filters);

      setData(response.items, response.totalItems);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  // Atualiza os dados quando a página ou o número de linhas por página muda
  useEffect(() => {
    fetchData(page, rowsPerPage, {
      tipoCompliance: filters.tipoCompliance || "",
      numeroSolicitacao: filters.numeroSolicitacao || "",
      dataSolicitacaoInicial: filters.dataSolicitacaoInicial || "",
      dataSolicitacaoFinal: filters.dataSolicitacaoFinal || "",
      nomeAuditor: filters.nomeAuditor || "",
      nomeProcesso: filters.nomeProcesso || "",
      nome: filters.nome || "",
      statusSolicitacao: filters.statusSolicitacao || "",
    });

  }, [page, rowsPerPage, filters]);

  // Manipula a mudança de página
  const handlePageChange = (newPage, newRowsPerPage) => {
    setPage(newPage);
    if (newRowsPerPage) {
      setRowsPerPage(newRowsPerPage);
    }
  };

  // Colunas da tabela
  const columns = [
    {
      title: 'NÚMERO',
      dataIndex: 'numeroSolicitacao',
      key: 'numeroSolicitacao',
      width: '20%',
      sorter: (a, b) => a.numeroSolicitacao.localeCompare(b.numeroSolicitacao),
    },
    {
      title: 'DATA',
      key: 'dataSolicitacao',
      width: '10%',
      render: (_, record) => formatDateToBR(record.dataSolicitacao),
      sorter: (a, b) => new Date(a.dataSolicitacao) - new Date(b.dataSolicitacao),
    },
    {
      title: 'AUDITOR',
      dataIndex: ['auditor', 'nome'],
      key: 'auditor',
      width: '20%',
      sorter: (a, b) => a.auditor.nome.localeCompare(b.auditor.nome),
      render: (text, record) => (
        <TextBlock>
          {text}
        </TextBlock>
      ),
    },
    {
      title: 'PROCESSO',
      dataIndex: ['compliance', 'nomeProcesso'],
      key: 'nomeProcesso',
      width: '20%',
      sorter: (a, b) => a.compliance.nomeProcesso.localeCompare(b.compliance.nomeProcesso),
      render: (text, record) => (
        <TextBlock>
          {text}
        </TextBlock>
      ),
    },
    {
      title: 'STATUS',
      key: 'statusSolicitacao',
      width: '20%',
      render: (_, record) => <StatusSolicitacaoComp status={record.statusSolicitacao} />,
      sorter: (a, b) => a.statusSolicitacao - b.statusSolicitacao,
    },
    {
      title: 'AÇÕES',
      key: 'actions',
      width: '10%',
      render: (_, record) => (
        <div className="d-flex justify-content-center gap-3">
          <NavigateSolicitacao row={record} />
        </div>
      ),
    },
  ];

  return (
    <div className='px-4'>

      <div className='mt-3 mb-3'>
        <i className="fa-solid fa-file fs-6" style={{ color: '#2b97be' }} />
        <span className='p-2 datatable-title'>Consulta - Solicitações</span>
      </div>

      <ConfigProvider locale={ptBR}>
        <StyledTable
          columns={columns}
          dataSource={state.data}
          rowKey="numeroSolicitacao"
          loading={{
            spinning: loading,
            indicator: <Spinner />,
          }}
          pagination={{
            current: page,
            pageSize: rowsPerPage,
            total: state.totalRows,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],
            onChange: handlePageChange,
            onShowSizeChange: handlePageChange,
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`,
          }}
          style={{ tableLayout: 'fixed', width: '100%' }}
          scroll={{ y: '20rem' }}
          locale={{
            emptyText: <h2 className='m-3'>Nenhuma solicitação disponível para exibição.</h2>,
          }}
        />
      </ConfigProvider>
    </div>
  );
};

export default GridConsultasSolicitacoesUnidadeGerencia;